import {FC} from 'react';
import {useField} from 'formik';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {TShow} from '../../../../../hooks/useShow';
import {RootState} from '../../../../../redux/store.type';
import {THall} from '../../../../../redux/timetable/timetable.type';
import DisabledInput from '../../../../../component/input/disabledInput/DisabledInput';

interface HallFieldProps {
    show: TShow;
}

const HallField: FC<HallFieldProps> = ({show}) => {
    const {t} = useTranslation('timetable');
    const [field] = useField<number | null>('thid');
    const halls = useSelector((state: RootState) => state.timetable.halls);

    const selected = halls.find((h: THall) => h.thid === field.value);

    const toggle = () => { if(show.isOpen) show.close(); else show.open(); };

    return (
        <DisabledInput
            text={t('placeOrHall')}
            placeholder={t('placeOrHall')}
            icon="hallOutline"
            value={selected?.title ?? ''}
            events={{onClick: toggle}}
            className=""
            dataCyName=""
            hasArrow
        />
    );
};

export default HallField;
